export const apiValidationMapping = [
    {
        id: "outletDetails",
        name: "Outlet Details",
        apiId: "outletDetails",
        validations: [
            {
                id: "outletDetails-empty-check",
                name: "Empty Data Check",
                params: {
                    key: "",
                },
                status: "",
                validateId: "emptyCheck",
            },
            {
                id: "outletDetails-key-check-outletCode",
                name: "outletCode key check",
                params: {
                    key: "outletCode",
                },
                status: "",
                validateId: "keyCheck",
            },
            {
                id: "outletDetails-key-check-location",
                name: "location key check",
                params: {
                    key: "location",
                },
                status: "",
                validateId: "keyCheck",
            },
        ],
    },
    {
        id: "products",
        name: "Products",
        apiId: "products",
        validations: [
            {
                id: "products-empty-check",
                name: "Empty Data Check",
                params: {
                    key: "",
                },
                status: "",
                validateId: "emptyCheck",
            },
            {
                id: "products-key-check-skucode",
                name: "skuCode Key Check",
                params: {
                    key: "skuCode",
                },
                status: "",
                validateId: "keyCheck",
            },
            {
                id: "products-key-check-batchCode",
                name: "batchCode Key Check",
                params: {
                    key: "batchCode",
                },
                status: "",
                validateId: "keyCheck",
            },
        ],
    },
    {
        id: "productmetaData",
        name: "Product MetaData",
        apiId: "productmetaData",
        validations: [
            {
                id: "productmetaData-empty-check",
                name: "Empty Data Check",
                params: {
                    key: "",
                },
                status: "",
                validateId: "emptyCheck",
            },
            {
                id: "productmetaData-key-check-batchCode",
                name: "batchCode Key Check",
                params: {
                    key: "batchCode",
                },
                status: "",
                validateId: "keyCheck",
            },
            {
                id: "productmetaData-key-check-mrp",
                name: "mrp Key Check",
                params: {
                    key: "mrp",
                },
                status: "",
                validateId: "keyCheck",
            },
            {
                id: "product-productMetaData-merge-check",
                name: "Product and Product MetaData Merge Check ",
                params: {
                    commonKey: "skuCode",
                },
                status: "",
                validateId: "productPricingMergeCheck",
            },
        ],
    },
    {
        id: "secondaryProduct",
        name: "Secondary Product",
        apiId: "secondaryProduct",
        validations: [
            {
                id: "secondaryProduct-empty-check",
                name: "Empty Data Check",
                params: {
                    key: "",
                },
                status: "",
                validateId: "emptyCheck",
            },
            {
                id: "secondaryProduct-key-check-batchCode",
                name: "batchCode Key Check",
                params: {
                    key: "batchCode",
                },
                status: "",
                validateId: "keyCheck",
            },
            {
                id: "secondaryProduct-key-check-feature",
                name: "feature Key Check",
                params: {
                    key: "feature",
                },
                status: "",
                validateId: "keyCheck",
            },
            {
                id: "secondaryProduct-merge-check",
                name: "Product , Pricing and Secondary Product Merge Check",
                params: {
                    commonKey: "skuCode",
                },
                status: "",
                validateId: "productPricingMergeCurentDataCheck",
            },
        ],
    },
    {
        id: "bannerDistribution",
        name: "Banner Distribution",
        apiId: "bannerDistribution",
        validations: [
            {
                id: "bannerDistribution-empty-check",
                name: "Empty Data Check",
                params: {
                    key: "",
                },
                status: "",
                validateId: "emptyCheck",
            },
        ],
    },
    {
        id: "recommendedOrders",
        name: "Recommended Orders",
        apiId: "recommendedOrders",
        validations: [
            {
                id: "recommendedOrders-empty-check",
                name: "Empty Data Check",
                params: {
                    key: "",
                },
                status: "",
                validateId: "emptyCheck",
            },
        ],
    },
];